module.exports = __webpack_public_path__ + "img/verified.3d82a16b.png";